import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private _httpClient = inject(HttpClient);

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get translation
     *
     * Os ficheiros i18n não são content-hashed pelo build (outputHashing só afeta
     * JS/CSS), logo o browser cacheia `./i18n/pt.json` e as traduções novas não
     * aparecem em produção após deploy.
     *
     * Força-se revalidação via HEADERS de request (Cache-Control/Pragma) em vez de
     * `?v=` na URL: a URL mantém-se, evitando o bug do nginx (`try_files $uri$args`
     * devolvia index.html para pedidos com query string → EmptyError no arranque).
     * Same-origin → sem preflight CORS.
     *
     * @param lang
     */
    getTranslation(lang: string): Observable<Translation> {
        return this._httpClient.get<Translation>(`./i18n/${lang}.json`, {
            headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' },
        });
    }
}
